import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AgenteClientService, TermsOfUse } from '@rsm/client/agente-client';
import { SecurityService } from '@rsm/shared/security';
import { Observable } from 'rxjs';
import { ThemeService } from '../../app/core/theme';
import { TermsOfUseAcceptDialogComponent } from './components/terms-of-use-accept-dialog/terms-of-use-accept-dialog.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  public userName: string;
  public logoUrl$: Observable<string | null>;
  private termsDialogOpened = false;

  constructor(
    private securityService: SecurityService,
    public router: Router,
    private themeService: ThemeService,
    private agenteClientService: AgenteClientService,
    private dialog: MatDialog
  ) {
    this.userName = this.securityService.credential?.username || 'Usuário';
    this.logoUrl$ = this.themeService.logoUrl$;
  }

  ngOnInit(): void {
    this.showPendingTermsOfUse();
  }

  public logout() {
    localStorage.removeItem('rsm_comet_token');
    localStorage.removeItem('rsm_comet_uid');
    this.securityService.logout();
    this.router.navigate(['/access/login']);
  }

  private showPendingTermsOfUse(): void {
    if (this.termsDialogOpened || !this.securityService.isValid()) {
      return;
    }

    this.agenteClientService.getPendingAppTermsOfUse().subscribe({
      next: (terms) => {
        if (!terms?.length) {
          return;
        }

        this.termsDialogOpened = true;
        this.openPendingTermDialog(terms, 0);
      },
      error: () => {
        // No active term or no linked agent: keep the regular navigation flow.
      },
    });
  }

  private openPendingTermDialog(terms: TermsOfUse[], index: number): void {
    const term = terms[index];
    if (!term) {
      this.termsDialogOpened = false;
      return;
    }

    this.dialog.open(TermsOfUseAcceptDialogComponent, {
      data: { term },
      disableClose: true,
      panelClass: 'terms-of-use-accept-dialog-panel',
    }).afterClosed().subscribe((accepted) => {
      if (accepted) {
        this.openPendingTermDialog(terms, index + 1);
        return;
      }
      this.termsDialogOpened = false;
    });
  }
}
